"use strict";

function shallowCopyObject(object) {
  var copy = {};
  Object.keys(object).forEach(function (key) {
    copy[key] = object[key];
  });
  return copy;
}

exports.shallowCopyObject = shallowCopyObject;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobiledoc-kit/dist/commonjs/mobiledoc-kit/utils/copy.js
// module id = 1486
// module chunks = 0